/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'


// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

VeeValidate.Validator.localize('th', {
  custom: {
    validate_email: {
      required: 'กรุณากรอกอีเมลล์',
      email: 'กรุณากรอกในรูปแบบของอีเมลล์',
      min: 'กรุณากรอกอีเมลล์มากกว่า 3 ตัวอักษร',
    },
    validate_password: {
      required: 'กรุณากรอกรหัสผ่าน',
      min: 'กรุณากรอกรหัสผ่านมากกว่า 6 ตัวอักษร',
      max: 'กรุณากรอกรหัสผ่านน้อยกว่า 10 ตัวอักษร',
    },
    validate_confirm_password: {
      required: 'กรุณากรอกยืนยันรหัสผ่าน',
      min: 'กรุณากรอกยืนยันรหัสผ่านมากกว่า 6 ตัวอักษร',
      max: 'กรุณากรอกยืนยันรหัสผ่านน้อยกว่า 10 ตัวอักษร',
    },
    validate_old_password: {
      required: 'กรุณากรอกรหัสผ่านเดิม',
      min: 'กรุณากรอกรหัสผ่านเดิมมากกว่า 6 ตัวอักษร',
      max: 'กรุณากรอกรหัสผ่านเดิมน้อยกว่า 10 ตัวอักษร',
    },
    validate_new_password: {
      required: 'กรุณากรอกรหัสผ่านใหม่',
      min: 'กรุณากรอกรหัสผ่านใหม่มากกว่า 6 ตัวอักษร',
      max: 'กรุณากรอกรหัสผ่านใหม่น้อยกว่า 10 ตัวอักษร',
    },
    validate_confirm_new_password: {
      required: 'กรุณากรอกยืนยันรหัสผ่านใหม่',
      min: 'กรุณากรอกยืนยันรหัสผ่านใหม่มากกว่า 6 ตัวอักษร',
      max: 'กรุณากรอกยืนยันรหัสผ่านใหม่น้อยกว่า 10 ตัวอักษร',
    }
  }
})
Vue.use(VeeValidate)


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
